import { css } from 'styled-components';

// Text that is hidden visually, but accessible to screen readers
// Taken from https://stackoverflow.com/a/26032207
export const screenReaderOnlyStyle = css`
  position: absolute; /* Outside the DOM flow */
  height: 1px;
  width: 1px; /* Nearly collapsed */
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE 7+ only support clip without commas */
  clip: rect(1px, 1px, 1px, 1px); /* All other browsers */
`;
